module.exports = __webpack_public_path__ + "static/media/bruvi-home.c14137b5.jpg";